import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { discountGroupObjects, DISOUNT_MASTER_CHANNEL_OPTIONS } from "./data";
import { GlobalState } from "context/GlobalContext";
import BrandChannel from "./BrandChannel/BrandChannel";
import ApplicableDate from "./ApplicableDateSection/ApplicableDate";
import DiscountValueSection from "./DiscountValueSection/DiscountValueSection";
import { Box, Button, Step, StepLabel, Stepper, Typography } from "@mui/material";
import MasterGeneralInformation from "./MasterGeneralInformation/MasterGeneralInformation";
import ProductSelectionSection from "./ProductSelectionSection/ProductSelectionSection";
import StoreAvailabilitySection from "./StoreAvailabilitySection/StoreAvailabilitySection";
import DiscountOverview from "./DiscountOverview/DiscountOverview";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import { AuthState } from "context/AuthContext";
import FinalSummary from "./summary/summary";
import { useLocation, useNavigate } from "react-router-dom";
import { generateSchemeStr, roleAccess } from "./DiscountMasterList";
import { DialogBox } from "./summary/dialogBox";

export function toMySQLDateTime(date) {
  const pad = (n) => n.toString().padStart(2, "0");

  return (
    date.getFullYear() + "-" +
    pad(date.getMonth() + 1) + "-" +
    pad(date.getDate()) + " " +
    pad(date.getHours()) + ":" +
    pad(date.getMinutes()) + ":" +
    pad(date.getSeconds())
  );
}

const jsDate =(date) =>{
	return new Date(date.replace(" ", "T") + "+05:30");
} 

const initial_state = {
		[discountGroupObjects.brand_channel.key]: {
			item_brand: "",
			channel: "",
		},
		[discountGroupObjects.general_information.key]: {
			scheme_type: "",
			scheme_name: "",
			// scheme_description: "",
		},
		[discountGroupObjects.applicable_date.key]: {
			start_date: "",
			end_date: "",
			applicable_days: [],
		},
		[discountGroupObjects.store_availability.key]: {
			zone: [],
			store: [],
			state: [],
			city: [],
			store_grade: [],
		},
		[discountGroupObjects.discount_value.key]: [],
		[discountGroupObjects.product_selection.key]: {
			// discount_product: [],
			discount_table: [],
			// nod: [],
		},
	};

	const convertApiToState = (data) => {
		return{
		[discountGroupObjects.brand_channel.key]: {
			item_brand: data.brand || "",
			channel: data.channel || "",
		},

		[discountGroupObjects.general_information.key]: {
			scheme_type: data.scheme_type || "",
			scheme_name: data.scheme_name || "",
		},

		[discountGroupObjects.applicable_date.key]: {
			start_date: jsDate(data.start_date) || "",
			end_date: jsDate(data.end_date) || "",
			applicable_days: data.applicable_days || [],
		},

		[discountGroupObjects.store_availability.key]: {
			zone: data.zone || [],
			store: data.store || [],
			state: data.state || [],
			city: data.city || [],
			store_grade: data.store_grade || [],
		},

		[discountGroupObjects.discount_value.key]: data.discounts || [],

		[discountGroupObjects.product_selection.key]: {
			discount_table: [],
		},
		}};

function DiscountMaster() {
	const location = useLocation();
	const discountData = location.state?.data;

	const [controlledSteps, setControlledSteps] = useState(0)
	const [value, setValue] = useState(discountData === undefined ? initial_state : convertApiToState(discountData));
	const [storeData, setStoreData] = useState({});
	const [barcodeFile, setBarcodeFile] = useState("");
	const [open, setOpen] = useState(false);
	const [finalSummary, setFinalSummary] = useState([]);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { user } = AuthState();

	const roleAccessData = roleAccess(user)
	
	const navigate = useNavigate();

	const prevStoreRef = useRef(value[discountGroupObjects.store_availability.key]);
	const prevBrandChannelRef = useRef(value[discountGroupObjects.brand_channel.key]);

	const stpesNames = [discountGroupObjects.brand_channel.key,
		discountGroupObjects.store_availability.key,
		discountGroupObjects.product_selection.key,
	discountGroupObjects.applicable_date.key,
	discountGroupObjects.general_information.key,
discountGroupObjects.discount_value.key]

const cascadeOrder = [
	"zone",
	"state",
	"city",
	"store_grade",
	"store",
];

	const getStores = async () => {
			try {
				// setDownloading(true);
				setLoadingOpen(true);
				await pythonVmInstance({
					url: `/discount-master/get`,
					headers: {
						"Content-Type": "application/json",
					},
					method: "GET",
				}).then((res) => {
					setStoreData(res?.data);
					discountData === undefined && setLoadingOpen(false);
				});
			} catch (error) {
				setSnackBarOpen(true);
				setLoadingOpen(false);
				setSnackBar({
					...snackBar,
					message: "Failed to download file",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			}
		};
	const getBarcodes = async () => {
			try {
				// setDownloading(true);
				setLoadingOpen(true);
				await pythonVmInstance({
					url: `/discount-master/get-barcodes`,params: { channel: value?.[discountGroupObjects.brand_channel.key]?.channel, barcode_url: discountData !== undefined ? discountData["barcode_file_url"] : null },
					headers: {
						"Content-Type": "application/json",
					},
					method: "GET",
				}).then((res) => {
					setValue({
						...value,
						[discountGroupObjects.product_selection.key]: {
							...value[discountGroupObjects.product_selection.key],
							discount_table: res?.data || []
						}
						});
					// setStoreData(res?.data);
					setLoadingOpen(false);
				});
			} catch (error) {
				setSnackBarOpen(true);
				setLoadingOpen(false);
				setSnackBar({
					...snackBar,
					message: "Failed to download file",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			}
		};
	

	const isFilled = (data) => {
	if (data === null || data === undefined) return false;

	// ✅ Array validation
	if (Array.isArray(data)) {
		if (data.length === 0) return false;

		return data.every((item) => isFilled(item));
	}

	// ✅ Object validation
	if (typeof data === "object") {
		return Object.values(data).every((val) => isFilled(val));
	}

	// ✅ Primitive validation
	return data !== "";
};

const handleStepperChange = () => {
	let countSteps = 0;

	for (let i = 0; i < stpesNames.length; i++) {
		const key = stpesNames[i];
		const stepValue = value[key];

		const allFilled = isFilled(stepValue);

		if (!allFilled) {
			countSteps = i;
			break;
		}

		countSteps = i + 1;
	}

	setControlledSteps(countSteps);
};

 const handleDropDownMissBeheviour = () =>{
	const currentBrand =
			value[discountGroupObjects.brand_channel.key];

		const currentStore =
			value[discountGroupObjects.store_availability.key];

		const prevBrand = prevBrandChannelRef.current;
		const prevStore = prevStoreRef.current;

		let updatedStore = { ...currentStore };
		let shouldUpdate = false;

		// ✅ 1. Brand/channel reset all
		if (
			prevBrand.item_brand !== currentBrand.item_brand ||
			prevBrand.channel !== currentBrand.channel
		) {
			updatedStore = {
				...initial_state[discountGroupObjects.store_availability.key],
			};

			shouldUpdate = true;
		}

		// ✅ 2. Cascading reset
		else {
			let changedKey = null;

			for (const key of cascadeOrder) {
				if (
					JSON.stringify(prevStore[key]) !==
					JSON.stringify(currentStore[key])
				) {
					changedKey = key;
					break;
				}
			}

			if (changedKey) {
				const index = cascadeOrder.indexOf(changedKey);

				for (let i = index + 1; i < cascadeOrder.length; i++) {
					if (updatedStore[cascadeOrder[i]].length > 0) {
						updatedStore[cascadeOrder[i]] = [];
						shouldUpdate = true;
					}
				}
			}
		}

		// ✅ 3. Apply update only if needed
		if (shouldUpdate) {
			setValue((prev) => ({
				...prev,
				[discountGroupObjects.store_availability.key]:
					updatedStore,
			}));
		}

		// ✅ 4. Save snapshots (primitive copy, no refs)
		prevBrandChannelRef.current = {
			item_brand: currentBrand.item_brand,
			channel: currentBrand.channel,
		};

		// ✅ Update refs AFTER logic
		prevStoreRef.current = JSON.parse(
			JSON.stringify(currentStore)
		);
		prevBrandChannelRef.current = JSON.parse(
			JSON.stringify(currentBrand)
		);
 }

	useEffect(() => {
		Object.keys(storeData).length > 0 && handleDropDownMissBeheviour();
		handleStepperChange();

		if (value[discountGroupObjects.discount_value.key].length === 0) {
			setFinalSummary([]);
		}else{
			handleFinalSummary();
		}
	}, [value]);


	useEffect(() => {
		getStores()
		discountData !== undefined && getBarcodes()
		return () => {
			setValue(initial_state)
		}
	}, []);

	const create_api_request = (form) =>{
		pythonVmInstance
				.post("/discount-master/create", form, { headers: { "Content-Type": "multipart/form-data" } })
				.then((res) => {
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Uploaded the files successfully",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					navigate(-1)
				})
				.catch((err) => {
					console.log("uploaded", err);
					const message = err?.response?.data?.message;
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: message ? message : "Unable to uploaded the files",
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
	}
	const update_api_request = (form) =>{
		form.append("id", discountData?.id);
		pythonVmInstance
				.put(`/discount-master/create`, form, { headers: { "Content-Type": "multipart/form-data" } })
				.then((res) => {
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Uploaded the files successfully",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					navigate(-1)
				})
				.catch((err) => {
					console.log("uploaded", err);
					const message = err?.response?.data?.message;
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: message ? message : "Unable to uploaded the files",
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
	}

	const handleSave = async (from) => {
			// e.preventDefault();
			setLoadingOpen(true);
			let form = new FormData();
			if (value[discountGroupObjects.product_selection.key].discount_table?.length === 0) {
				// setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Please upload some files and try again",
					severity: "warning",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
				return;
			}
			let discount_details = {}

			discount_details["brand"] = value[discountGroupObjects.brand_channel.key]?.item_brand || ''
			discount_details["channel"] = value[discountGroupObjects.brand_channel.key]?.channel || ''
			discount_details["scheme_type"] = value[discountGroupObjects.general_information.key]?.scheme_type || ''
			discount_details["scheme_name"] = value[discountGroupObjects.general_information.key]?.scheme_name || ''
			discount_details["start_date"] = toMySQLDateTime(value[discountGroupObjects.applicable_date.key]?.start_date) || ''
			discount_details["end_date"] = toMySQLDateTime(value[discountGroupObjects.applicable_date.key]?.end_date) || ''
			discount_details["applicable_days"] = value[discountGroupObjects.applicable_date.key]?.applicable_days || []
			discount_details["discount_value"] = value[discountGroupObjects.discount_value.key] || []
			discount_details["city"] = value[discountGroupObjects.store_availability.key]?.city || []
			discount_details["state"] = value[discountGroupObjects.store_availability.key]?.state || []
			discount_details["zone"] = value[discountGroupObjects.store_availability.key]?.zone || []
			discount_details["store_grade"] = value[discountGroupObjects.store_availability.key]?.store_grade || []
			discount_details["store"] = value[discountGroupObjects.store_availability.key]?.store || []
			discount_details["submitted_by"] = from === "submit" ? user?.email : null
			discount_details["submitted_at"] = from === "submit" ? toMySQLDateTime(new Date()) : null
			discount_details["created_by"] = user?.email || null
			discount_details["updated_by"] = user?.email || null
			discount_details["discount_str"] = finalSummary[0]?.scheme
			discount_details["updated_at"] = discountData !== undefined ? toMySQLDateTime(new Date()) : null
			discount_details["status"] = from === "submit" ? "Submitted" : "Draft"
			discount_details["barcode_file_url"] = discountData !== undefined ? discountData["barcode_file_url"] : null

			form.append("files", barcodeFile);
			form.append("discount_details", JSON.stringify(discount_details));
			form.append("from", from);
			
			if (discountData !== undefined) {
				update_api_request(form)
			}
			else{
				create_api_request(form)
			}

		};

	const handleFileUpload = async (e) => {
			e.preventDefault();
			setLoadingOpen(true);
			let form = new FormData();
			if (barcodeFile === "") {
				// setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Please upload some files and try again",
					severity: "warning",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
				return;
			}
	
			form.append("files", barcodeFile);
			form.append("email", user.email);
			form.append("channel", value?.[discountGroupObjects.brand_channel.key]?.channel);
			pythonVmInstance
				.post("/discount-master/upload-barcodes", form, { headers: { "Content-Type": "multipart/form-data" } })
				.then((res) => {
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Uploaded the files successfully",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					console.log("sldjlisjdfhasdf", res?.data)
					setValue({
						...value,
						[discountGroupObjects.product_selection.key]: {
							...value[discountGroupObjects.product_selection.key],
							discount_table: res?.data
						}
						});
					// setBarcodeFile("");
					// document.getElementById("fileInput").value = "";
				})
				.catch((err) => {
					console.log("uploaded", err);
					const message = err?.response?.data?.message;
					setLoadingOpen(false);
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: message ? message : "Unable to uploaded the files",
						severity: "error",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
		};
	
	const handleFinalSummary = () => {
		let data = value[discountGroupObjects.product_selection.key]?.discount_table.map(element => {
			return {...element,
				'scheme': generateSchemeStr(value[discountGroupObjects.discount_value.key], value[discountGroupObjects.general_information.key]?.scheme_type) || '',
				'scheme_name': value[discountGroupObjects.general_information.key]?.scheme_name || '',
				'date': `${value[discountGroupObjects.applicable_date.key]?.start_date || ''} to ${value[discountGroupObjects.applicable_date.key]?.end_date || ''}`,
				'days': value[discountGroupObjects.applicable_date.key]?.applicable_days || [],
			}
		});
		setFinalSummary(data);
	};

	let itemBrandOptions = storeData?.item_master?.filter(brand => roleAccessData?.brandList.includes(brand["item_brand"]))?.map((brand) => {
		return { name: brand["item_brand"], key: brand["item_brand"] };
	});

	let channelOptions =DISOUNT_MASTER_CHANNEL_OPTIONS?.filter(channel => roleAccessData?.channelList.includes(channel["name"]));

	let allChannels = [
	...(storeData?.ebo_stores || []),
	...(storeData?.lfs_stores || []),
	...(storeData?.mbo_stores || [])
	].flat();

	let storeDetails = allChannels?.filter((store) => store.channel.trim() === value?.[discountGroupObjects.brand_channel.key]?.channel && store?.brand.trim() === value?.[discountGroupObjects.brand_channel.key]?.item_brand )


	return (
		<Box width="100%" pt={4}>
			<Box display="flex" flexDirection={"row"} width={"100%"} justifyContent={"space-between"}>
				<Box width={"45%"}>
					<Stepper orientation="vertical" nonLinear activeStep={controlledSteps}>
						<Step expanded completed={controlledSteps > 0}>
							<StepLabel>Brand and Channel Selection</StepLabel>
							<Box mt={2} mb={4}>
								<BrandChannel value={value} setValue={setValue} disable={controlledSteps < 0} data={{"item_brand": itemBrandOptions, "channel":channelOptions }} />
							</Box>
						</Step>
						<Step expanded completed={controlledSteps > 1}>
							<StepLabel>Store Availability</StepLabel>
							<Box mt={2} mb={4} width={"90%"}>
								<StoreAvailabilitySection value={value} setValue={setValue} disable={controlledSteps < 1 } data = {storeDetails} />
							</Box>
						</Step>
						<Step expanded completed={controlledSteps > 2}>
							<StepLabel>Product Selection</StepLabel>
							<Box mt={2} mb={4}>
								<ProductSelectionSection value={value} setValue={setValue} disable={controlledSteps < 2} onBlurEvent = {getStores} barcodeFile={barcodeFile} setBarcodeFile={setBarcodeFile} handleFileUpload = {handleFileUpload} table_data = {value?.[discountGroupObjects.product_selection.key]?.discount_table} />
							</Box>
						</Step>

						<Step expanded completed={controlledSteps > 3}>
							<StepLabel>Applicable Date</StepLabel>
							<Box mt={2} mb={4} width={"90%"}>
								<ApplicableDate value={value} setValue={setValue} disable={controlledSteps < 3} />
							</Box>
						</Step>
						<Step expanded completed={controlledSteps > 4}>
							<StepLabel>General Information</StepLabel>
							<Box mt={2} mb={4}>
								<MasterGeneralInformation value={value} setValue={setValue} disable={controlledSteps < 4} />
							</Box>
						</Step>
						<Step expanded completed={controlledSteps > 5}>
							<StepLabel>Discount Value</StepLabel>
							<Box mt={1} mb={4} width={"90%"}>
								<DiscountValueSection value={value} setValue={setValue}  disable={controlledSteps < 5} handleFinalSummary = {handleFinalSummary} setFinalSummary={setFinalSummary} />
							</Box>
						</Step>
					</Stepper>
				</Box>
				<Box width={"52%"} display={"flex"} position={"sticky"} right={0} top={80} flexDirection={"column"} alignItems={"center"} rowGap={2}
				sx={{
						height: "calc(100vh - 100px)", // limit height relative to viewport
						overflowY: "auto",            // enable scroll inside
						// paddingRight: 2,              // optional scrollbar spacing
					}}
				>
					<DiscountOverview />
				</Box>
			</Box>
			<Box>
				<FinalSummary data = {finalSummary} />
			</Box>
			<Box mt={4} display="flex" justifyContent="flex-end" columnGap={2}>
				<Button variant="contained" onClick={() => handleSave( "save")} disabled={finalSummary.length === 0 || controlledSteps < 6}>
					Save
				</Button>
				<Button variant="contained" onClick={setOpen} disabled={finalSummary.length === 0 || controlledSteps < 6}>
					Submit
				</Button>
			</Box>
			<DialogBox open={open} setOpen={setOpen} body={"This action is irreversible. Do you want to proceed? An approval request will be sent via email."} handleOK={() => handleSave("submit")} />
		</Box>
	);
}

export default DiscountMaster;
